import { EDataSourceStatus } from '@/models/dataSource';
import { CSSProperties } from 'react';
import { HomeDestinationChartStatus } from './types';

export const DESTINATIONS_CHART_STROKE_WIDTH = 10;

export const HOME_DESTINATIONS_CHART_GROUPS: Record<HomeDestinationChartStatus, { statuses: EDataSourceStatus[]; color: CSSProperties['backgroundColor'] }> = {
  availableToActivate: {
    statuses: [EDataSourceStatus.ACTIVATING, EDataSourceStatus.PENDING, EDataSourceStatus.CONFIGURATION_REQUIRED],
    color: 'var(--gray-500)',
  },
  inactive: {
    statuses: [EDataSourceStatus.ERROR],
    color: 'var(--brand-500)',
  },
  active: {
    statuses: [EDataSourceStatus.ACTIVE],
    color: 'var(--brand-700)',
  },
};
